var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { CustomButton, LucidLinkIcon, Trans } from '@lucidlink/uicore';
export const OnboardingTrigger = ({ completedSteps, hasChange, isFloatingBoxActive: _isFloatingBoxActive, ...triggerProps }) => {
    return (_jsx(CustomButton, { ...triggerProps, "data-testid": "open-onboarding", hasChange: hasChange, labelProps: {
            max: 3,
            current: completedSteps || 0,
        }, StartIcon: LucidLinkIcon, children: _jsx(Trans, { children: "Get Started" }) }));
};
_react_refresh_temp_1 = OnboardingTrigger;
$RefreshReg$(_react_refresh_temp_1, "OnboardingTrigger");
